import { checkIsInEditor } from '@/hooks/use-is-in-editor';

const AuthoringHelper = Object.freeze({ isInEditor: checkIsInEditor() });

export default AuthoringHelper;
